// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__s9dme","signatureButtonsRight":"ModalSign_signatureButtonsRight__1pbJ2"};